import React from "react";
import Select from "react-select";
import { IoClose, IoCheckmark } from "react-icons/io5";
import {
  materialUnitOptions,
  supplyApplyOptions,
  boqTypeOptions,
  requiresLeadTime,
} from "../../../../../constants/boq";

const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 44,
    height: 44,
    borderRadius: 12,
    borderColor: "#d1d5db",
    fontSize: 12,
    boxShadow: "none",
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  indicatorsContainer: (base) => ({ ...base, height: 44 }),
  menu: (base) => ({ ...base, fontSize: 12 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const InlineAddCategoryItemRow = ({
  pendingItem,
  onUpdate,
  onSave,
  onCancel,
  isSaving,
  selectableRooms = null,
}) => {
  const roomOptions = selectableRooms?.map((r) => ({ value: r.id, label: r.name })) || [];

  const handleNumberChange = (value) => {
    const cleaned = value === "" ? "" : value.replace(/[^0-9]/g, "");
    if (cleaned === "" || (!isNaN(cleaned) && parseInt(cleaned) >= 0)) {
      if (pendingItem.boq_type === "Materials") onUpdate({ quantity: cleaned, days: "" });
      else onUpdate({ days: cleaned, quantity: "" });
    }
  };

  const fieldStyle = { position: "relative", minWidth: 100, flex: 1, fontSize: 12 };
  const inputStyle = {
    height: 44,
    width: "100%",
    borderRadius: 12,
    border: "1px solid #d1d5db",
    padding: "8px 12px 0",
    fontSize: 14,
    color: "#0D0D0E",
    boxSizing: "border-box",
  };
  const floatLabelStyle = {
    position: "absolute",
    left: 12,
    top: -8,
    fontSize: 12,
    color: "#6b7280",
    background: "#fff",
    padding: "0 4px",
  };

  return (
    <div
      style={{
        position: "relative",
        zIndex: 10,
        display: "flex",
        gap: 16,
        backgroundColor: "#fff",
        border: "2px solid #fdba74",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", marginBottom: 12 }}>
          <div style={fieldStyle}>
            <input
              style={inputStyle}
              value={pendingItem.item_name || ""}
              onChange={(e) => onUpdate({ item_name: e.target.value })}
            />
            <label style={floatLabelStyle}>Item Name</label>
          </div>

          <div style={fieldStyle}>
            <Select
              value={supplyApplyOptions.find((o) => o.value === pendingItem.supply_apply) || null}
              onChange={(selected) => {
                const nextVal = selected?.value || null;
                onUpdate({
                  supply_apply: nextVal,
                  ...(requiresLeadTime(nextVal) ? {} : { lead_time: "" }),
                });
              }}
              options={supplyApplyOptions}
              styles={selectStyles}
              menuPosition="fixed"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            />
            <label style={floatLabelStyle}>Supply/Apply</label>
          </div>

          {requiresLeadTime(pendingItem.supply_apply) && (
            <div style={fieldStyle}>
              <input
                type="text"
                inputMode="numeric"
                style={inputStyle}
                placeholder="Days"
                value={pendingItem.lead_time || ""}
                onChange={(e) =>
                  onUpdate({
                    lead_time: e.target.value.replace(/[^0-9]/g, ""),
                  })
                }
              />
              <label style={floatLabelStyle}>Lead Time (days)</label>
            </div>
          )}

          <div style={fieldStyle}>
            <input
              style={inputStyle}
              placeholder={pendingItem.boq_type === "Activities" ? "Days" : "Qty"}
              value={pendingItem.boq_type === "Materials" ? pendingItem.quantity || "" : pendingItem.days || ""}
              onChange={(e) => handleNumberChange(e.target.value)}
              type="text"
              inputMode="numeric"
            />
            <label style={floatLabelStyle}>
              {pendingItem.boq_type === "Activities" ? "Days" : "Quantity"}
            </label>
          </div>

          {pendingItem.boq_type === "Materials" && (
            <div style={fieldStyle}>
              <Select
                value={materialUnitOptions.find((o) => o.value === pendingItem.material_unit) || null}
                onChange={(selected) => onUpdate({ material_unit: selected?.value || null })}
                options={materialUnitOptions}
                styles={selectStyles}
                menuPosition="fixed"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              />
              <label style={floatLabelStyle}>Material Unit</label>
            </div>
          )}

          {roomOptions.length > 0 && (
            <div style={fieldStyle}>
              <Select
                value={roomOptions.find((o) => o.value === pendingItem.room_id) || null}
                onChange={(selected) => onUpdate({ room_id: selected?.value ?? null })}
                options={roomOptions}
                placeholder="Select room"
                styles={selectStyles}
                menuPosition="fixed"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              />
              <label style={floatLabelStyle}>Room</label>
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <div style={{ flex: 1, position: "relative", minWidth: 0 }}>
            <Select
              value={
                boqTypeOptions.find((o) => o.value === (pendingItem.boq_type || "Materials")) || boqTypeOptions[0]
              }
              onChange={(selected) => {
                const newType = selected?.value || "Materials";
                onUpdate(
                  newType === "Materials"
                    ? { boq_type: newType, days: "" }
                    : { boq_type: newType, quantity: "", material_unit: null },
                );
              }}
              options={boqTypeOptions}
              styles={selectStyles}
              menuPosition="fixed"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            />
            <label style={floatLabelStyle}>Material Type</label>
          </div>

          <div style={{ flex: 2, position: "relative", minWidth: 0 }}>
            <input
              style={inputStyle}
              placeholder="Enter specification"
              value={pendingItem.specification || ""}
              onChange={(e) => onUpdate({ specification: e.target.value })}
            />
            <label style={floatLabelStyle}>Specifications</label>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, alignItems: "center", flexShrink: 0 }}>
        <button
          onClick={onSave}
          disabled={isSaving}
          style={{
            padding: 8,
            color: "#16a34a",
            background: "transparent",
            border: "none",
            borderRadius: 8,
            cursor: isSaving ? "not-allowed" : "pointer",
            opacity: isSaving ? 0.5 : 1,
          }}
          title="Save item"
        >
          <IoCheckmark style={{ width: 20, height: 20 }} />
        </button>
        <button
          onClick={onCancel}
          disabled={isSaving}
          style={{
            padding: 8,
            color: "#ef4444",
            background: "transparent",
            border: "none",
            borderRadius: 8,
            cursor: isSaving ? "not-allowed" : "pointer",
            opacity: isSaving ? 0.5 : 1,
          }}
          title="Cancel"
        >
          <IoClose style={{ width: 20, height: 20 }} />
        </button>
      </div>
    </div>
  );
};

export default InlineAddCategoryItemRow;
